/**
 * Self-Improving Workflow Demo — registry entries.
 *
 * THROWAWAY DEMO CODE. Side-effecting registration (imported once from
 * `@/demo/init`): registers the demo with the shared controls/provider registry
 * and the oRPC client-link resolver.
 */

import { registerDemo } from '@/demo/core/demo-registry';
import { registerDemoClientResolver } from '@/demo/core/demo-client';
import { WORKFLOW_RECOVERY_DEMO_KEY } from './demo-mode';
import { workflowRecoveryStore } from './fixture-store';
import { workflowRecoveryResolver } from './resolver';

registerDemo({
  key: WORKFLOW_RECOVERY_DEMO_KEY,
  label: 'Self-Improving Workflows',
  accent: {
    badge: 'border-violet-200',
    label: 'text-violet-700',
    resetButton: 'bg-violet-600 hover:bg-violet-700',
  },
  reset: () => {
    workflowRecoveryStore.reset();
  },
  StoreProvider: workflowRecoveryStore.StoreProvider,
});

registerDemoClientResolver(
  WORKFLOW_RECOVERY_DEMO_KEY,
  workflowRecoveryResolver,
);
